import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { UiWarningIcon } from "@jti/brand-icons/ui-warning";
import { FormField } from "../../../../components/Form";
import { OtpInput } from "../../../../components/OtpInput";
import { Txt } from "../../../../components/Txt";
import { useTranslations } from "../../../../providers/useTranslations";
import { restrictToAlphaNumericKey } from "../../../../utils/restrictToAlphaNumericKey";
import styles from "./OtpInputSection.module.scss";
const CONSTANTS = {
    OTP_LENGTH: 4,
    ERROR_STYLE: {
        // TODO: refactor OtpInput to new design system
        border: "2px solid var(--des-color-stroke-error)",
    },
};
export const OtpInputSection = ({ fieldName, dataTestId, inputStyle, isInputNum, autocompleteType, isAttemptError, attemptsNum, isDisabled, }) => {
    const { __ } = useTranslations();
    return (_jsxs("div", { className: styles.otpInputSectionContainer, onKeyDown: restrictToAlphaNumericKey, children: [_jsx(Txt, { className: styles.otp, children: __("profile.phone_update_page.otp") }), _jsx(FormField, { name: fieldName("phone_validation_code"), render: ({ field }) => (_jsx(OtpInput, { ...field, "data-testid": dataTestId, inputStyle: classNames(inputStyle, styles.inputStyle), isInputNum: isInputNum, autocompleteType: autocompleteType, hasErrored: isAttemptError, errorStyle: CONSTANTS.ERROR_STYLE, isDisabled: isDisabled, containerStyle: styles.otpInputContainer })), validation: {
                    required: __("auth.registration.otp.validation.field_required"),
                    minLength: {
                        value: CONSTANTS.OTP_LENGTH,
                        message: __("auth.registration.otp.validation.field_min_length"),
                    },
                } }), isAttemptError && (_jsxs("div", { className: styles.errorAttempt, children: [_jsx(UiWarningIcon, { className: styles.errorIcon }), _jsx("span", { children: __("auth.login.sms_verify.attempts_left", [attemptsNum]) })] }))] }));
};
//# sourceMappingURL=OtpInputSection.js.map